import { z } from "zod";

/**
 * All execution statuses, including transient/interim states used during
 * orchestration. This is the canonical superset — persistence may store
 * any of these values.
 */
export const EXECUTION_STATUS_VALUES = [
  "pending",
  "queued",
  "running",
  "in_progress",
  "waiting",
  "updated",
  "succeeded",
  "completed",
  "canceled",
  "failed",
  "cancelled",
  "error",
  "timed_out",
  "blocked",
] as const;

export const executionStatusSchema = z.enum(EXECUTION_STATUS_VALUES);
export type ExecutionStatus = z.infer<typeof executionStatusSchema>;

/**
 * Interim statuses represent in-flight execution states that have not
 * yet reached a terminal outcome.
 */
const INTERIM_EXECUTION_STATUS_VALUES = [
  "pending",
  "queued",
  "running",
  "in_progress",
  "waiting",
  "updated",
] as const;

export const interimExecutionStatusSchema = z.enum(
  INTERIM_EXECUTION_STATUS_VALUES,
);
export type InterimExecutionStatus = z.infer<
  typeof interimExecutionStatusSchema
>;

const interimSet: ReadonlySet<string> = new Set(
  INTERIM_EXECUTION_STATUS_VALUES,
);

export function isInterimExecutionStatus(
  value: string,
): value is InterimExecutionStatus {
  return interimSet.has(value);
}
